import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { LockIcon } from 'lucide-react';
import { HomeHero } from '../components/home/HomeHero';
import { RetreatHighlights } from '../components/home/RetreatHighlights';
import { AgendaTimeline } from '../components/home/AgendaTimeline';
import { DestinationCarousel } from '../components/home/DestinationCarousel';
import { DestinationComparison } from '../components/home/DestinationComparison';
import { VoteSection } from '../components/home/VoteSection';
export function Home() {
  const [selectedLocationId, setSelectedLocationId] = useState<string | null>(null);
  const scrollTo = useCallback((id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, []);
  function chooseDestination(locationId: string) {
    setSelectedLocationId(locationId);
    window.setTimeout(() => scrollTo('vote'), 40);
  }
  return <div id="top" className="min-h-screen w-full bg-[#fbfaf6] text-[#29433b]" data-id="element-379" data-mp="3ovavakid1b8x">
      <HomeHero onExplore={() => scrollTo('destinations')} data-id="element-380" data-mp="30vqak2006st2" />
      <RetreatHighlights data-id="element-381" data-mp="2vxyagkp7g0ds" />
      <AgendaTimeline data-id="element-382" data-mp="2vxf0pr9pkiau" />
      <DestinationCarousel onChoose={chooseDestination} data-id="element-383" data-mp="2vy80u9e5w9k0" />
      <DestinationComparison data-id="element-384" data-mp="2qy2hdgi1ptd0" />
      <VoteSection selectedLocationId={selectedLocationId} data-id="element-385" data-mp="2qxakm2cpppl5" />
      <footer className="bg-[#233f36] px-5 py-8 text-center text-sm text-white/65 sm:px-8" data-id="element-386" data-mp="2mxa5sglpbcdk">
        <p data-id="element-387" data-mp="2hxnj7gjzgjs3">2026 Board Retreat · Made for considered decisions and meaningful connection.</p>
        <Link to="/admin" className="mt-3 inline-flex items-center gap-1.5 font-700 text-[#efd68e] transition hover:text-white" data-id="element-388" data-mp="2d777c0vt967u"><LockIcon className="h-3.5 w-3.5" data-id="element-389" data-mp="287ku3rfzfpz1" /> Administrator dashboard</Link>
      </footer>
    </div>;
}